/** POS kategori katalogu — yeniislem.js listeleri ile aynı isimler. */

import { TAKI_URUN_TIPLERI } from '../takiUrunTipleri';

export const POS_CATALOG = {
  Sarrafiye: [
    'Eski Ziynet Çeyrek', 'Yeni Ziynet Çeyrek', 'Eski Ziynet Yarım', 'Yeni Ziynet Yarım',
    'Eski Ziynet Tam', 'Yeni Ziynet Tam', "Eski Ziynet 2.5'lu Gremse", "Yeni Ziynet 2.5'lu Gremse",
    'Eski Ziynet Beşli', 'Yeni Ziynet Beşli', 'Cumhuriyet Ata Çeyrek', 'Cumhuriyet Ata Yarım',
    'Cumhuriyet Ata', "Cumhuriyet Ata 2.5'lu", 'Cumhuriyet Ata Beşli',
    'Reşat Çeyrek', 'Reşat Yarım', 'Reşat', "Reşat 2.5'lu", 'Reşat Beşli'
  ],
  'Gram Altın': [
    '1 Gram 22 Ayar', '0.50 Gram 22 Ayar', '0.25 Gram 22 Ayar', '1 Gram 24 Ayar',
    '0.50 Gram 24 Ayar', '0.25 Gram 24 Ayar', '2.50 Gram 24 Ayar', '5 Gram 24 Ayar',
    '10 Gram 24 Ayar', '20 Gram 24 Ayar', '50 Gram 24 Ayar', '100 Gram 24 Ayar'
  ],
  Hurda: [
    '24 Ayar Hurda', '22 Ayar Bilezik Hurda', '22 Ayar Hurda', '21 Ayar Hurda',
    '18 Ayar Hurda', '14 Ayar Hurda', '8 Ayar Hurda'
  ],
  Döviz: [
    'TL - Türk Lirası', 'USD - Amerikan Doları', 'EUR - Euro', 'GBP - İngiliz Sterlini',
    'CHF - İsviçre Frangı', 'AUD - Avustralya Doları', 'CAD - Kanada Doları',
    'SAR - Suudi Arabistan Riyali', 'AED - Birleşik Arap Emirlikleri Dirhemi',
    'QAR - Katar Riyali', 'MAD - Fas Dirhemi', 'JOD - Ürdün Dinarı',
    'KWD - Kuveyt Dinarı', 'CNY - Çin Yuanı', 'RUB - Rus Rublesi', 'BGN - Bulgar Levası'
  ],
  'Takı Ürün': [...TAKI_URUN_TIPLERI]
};

export function catalogProductId(kategori, urun) {
  return `catalog:${kategori}:${urun}`;
}

export function isCatalogProductId(id) {
  return String(id || '').startsWith('catalog:');
}

export function buildCatalogProducts() {
  const rows = [];
  Object.entries(POS_CATALOG).forEach(([kategori, items]) => {
    items.forEach((urun) => {
      rows.push({
        id: catalogProductId(kategori, urun),
        barkod: null,
        isim: urun,
        kategori,
        urunTipi: urun,
        gram: null,
        urunMilyem: null,
        iscilik: null,
        adetIscilik: null,
        hasAltinKuru: null,
        stok: null,
        isCatalog: true
      });
    });
  });
  return rows;
}
